/*
 *   File : terms-conditions.js
 *   Author : https://evoqins.com
 *   Description : Terms and conditions page
 *   Integrations : 
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { TextButton } from "../../Component/Buttons";
import { _scrollToTop } from "../../Helper";
import { APIService } from "../../Service";
import { Loader } from "../../Component/Others";


function TermsAnsConditions(props) {

    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();

        // API call
        _getTermsAndConditionsDATA();
    }, []);

    const _handleBack = () => {
        navigate(-1);
        props.handlePublicRouter();
    };

    // API call
    const _getTermsAndConditionsDATA = async () => {

        let url = "organization/static-details";
        let data = {
            "type": "TERMS_AND_CONDITIONS"
        };
        let is_post = true;
        let token = "my-auth-token";

        const response = await APIService(url, data, is_post, token);
        if (response.status_code === 200) {
            setData(response.data.htmlContent);
        } else {
            setData("");
        }
        setDataLoading(false);
    };

    return (
        <>
            <TextButton name="Terms & Conditions"
                icon={true}
                type={2}
                onPress={_handleBack} />

            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-200px-top" />
                    :
                    <div id="terms-conditions" className="p-3 card-box-shadow e-bg-white mt-4 border-radius-8 d-flex flex-column gap-3">
                        <div dangerouslySetInnerHTML={{ __html: data }}></div>
                    </div>
            }
        </>
    )
}

export default TermsAnsConditions;